module.exports = __webpack_public_path__ + "static/media/Catalogo-Colaboradores.e1ef8b2d.png";